import React, { useEffect, useRef } from "react";
import { X } from "lucide-react";

const AppDrawer = ({
  open,
  onClose,
  title,
  children,
  footer,
  className = "",
  allowBackdropClose = true,
}) => {
  const panelRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleKey = (e) => {
      if (e.key === "Escape" && allowBackdropClose) {
        if (onClose) onClose();
      }
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [open, onClose, allowBackdropClose]);

  return (
    <div
      className={`drawer-overlay ${open ? "is-open" : ""}`}
      onClick={() => {
        if (allowBackdropClose && onClose) onClose();
      }}
    >
      <aside
        ref={panelRef}
        className={`drawer-panel ${open ? "is-open" : ""} ${className}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title || "Drawer"}
      >
        <div className="drawer-header">
          <h2 className="drawer-title">{title}</h2>
          <button className="drawer-close" onClick={onClose} aria-label="Inchide">
            <X size={18} />
          </button>
        </div>
        <div className="drawer-body">{children}</div>
        {footer && <div className="drawer-footer">{footer}</div>}
      </aside>
    </div>
  );
};

export default AppDrawer;
